module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/cyclebar-2495c499f7f75642a5bc916a8716406b.png";